import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Terms = () => {
  useEffect(() => {
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>
        <section className="ul-breadcrumb ul-section-spacing" style={{backgroundImage: "url('/assets/new-img/connections-between-people-groups-and-teams-2025-03-18-18-53-59-utc.jpg')"}}>
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">Terms &amp; Conditions</h2>
            <ul className="ul-breadcrumb-nav">
              <li><Link to="/">Home</Link></li>
              <li><span className="separator"><i className="flaticon-right"></i></span></li>
              <li>Terms &amp; Conditions</li>
            </ul>
          </div>
        </section>

        <section className="ul-section-spacing">
          <div className="ul-container">
            <div style={{maxWidth: '900px', margin: '0 auto'}}>

              <div style={{marginBottom: 'clamp(20px, 2.1vw, 30px)'}}>
                <p style={{fontSize: 'clamp(14px, 0.95vw, 16px)', color: 'rgba(0,0,0,0.5)'}}>Effective Date: January 29, 2026</p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>1. Acceptance of Terms</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  By accessing or using the Pathio website (pathio.org), you agree to be bound by these Terms &amp; Conditions. If you do not agree with any part of these terms, please do not use the site.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>2. About Pathio</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  Pathio is a student-led nonprofit organization dedicated to improving public health literacy within Uzbek and Central Asian communities. We create educational health content and connect people to local resources.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>3. Use of the Website</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>You agree to use this site only for lawful purposes. You may not:</p>
                <ul style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 2, color: 'rgba(0,0,0,0.7)', paddingLeft: 'clamp(20px, 2.1vw, 30px)', marginTop: 'clamp(10px, 1.05vw, 15px)'}}>
                  <li>Use the site in any way that violates applicable laws or regulations.</li>
                  <li>Attempt to gain unauthorized access to any part of the site.</li>
                  <li>Reproduce, distribute, or modify any content without written permission.</li>
                  <li>Use the site to transmit harmful or malicious content.</li>
                </ul>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>4. Intellectual Property</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  All content on this site — including text, images, graphics, logos, and educational materials — is the property of Pathio or its content creators and is protected by copyright and intellectual property laws. You may share our content for personal, non-commercial, educational purposes with proper attribution.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>5. Donations</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  Donations made through our website are processed securely by third-party payment providers (e.g., Stripe). All donations are non-refundable and tax-deductible to the extent allowed by law. By making a donation, you confirm that the payment method used is yours or that you are authorized to use it.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>6. Educational Content Disclaimer</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  The health-related content provided on this site is for educational and informational purposes only. It is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of a qualified healthcare provider with any questions regarding a medical condition.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>7. External Links</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  Our site may contain links to third-party websites. These links are provided for convenience and do not imply endorsement. Pathio is not responsible for the content or practices of external sites.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>8. Limitation of Liability</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  Pathio provides this website and its content on an "as is" basis. We make no warranties regarding the accuracy, completeness, or reliability of any content. Pathio shall not be liable for any damages arising from the use of this site.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>9. Changes to These Terms</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  We may update these Terms &amp; Conditions from time to time. Changes will be posted on this page with an updated effective date. Continued use of the site after changes constitutes acceptance of the revised terms.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>10. Contact</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  If you have any questions about these terms, please contact us at{' '}
                  <a href="mailto:pathio.org@gmail.com" style={{color: 'var(--ul-primary)', textDecoration: 'none'}}>pathio.org@gmail.com</a>.
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Terms;
